module.exports = __webpack_public_path__ + "img/1536779644.2c2e5aaa.jpg";